<template>
  <b-card no-body>

    <b-card-header class="pb-50">
      <h5>人員行事曆</h5>
      <div>
          <button-copy-url
            tip="複製目前人員行事曆網址"
            @click="CopyButtonClick"
          />
      </div>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <label>部門線別</label>

          <v-select
            v-model="departmentSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="departmentOptions"
            class="w-100"
            @input="(val) => ProdLine_Selected(val)"
          />
        </b-col>
        <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <label>員工</label>
          <v-select
            v-model="staffSelected"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="staffOptions"
            :disabled="isReadonly"
            class="w-100"
            @input="(val) => Set_Query_StaffNo(val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";
import store from '@/store'
import pageJs from '../../js'
import { reactive, getCurrentInstance, ref, onMounted, computed, watch, watchEffect } from '@vue/composition-api'
import tools from '@/sag-core/tools'
import ButtonCopyUrl from '../ButtonCopyUrl.vue'
export default {
  name: "query-drop-down",
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    ButtonCopyUrl
  },
  props: {
    staffNo: {
      type: String,
      default: ''
    },
    lineCode: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }){
    const departmentOptions = ref([])
    const departmentSelected = ref(null)
    const staffOptions = ref([])
    const staffSelected = ref(null)
    const isReadonly = computed({
      get: ()=>{ return departmentSelected.value ? false : true }
    })


    const $bvToast = getCurrentInstance().proxy.$bvToast
    const CopyButtonClick = ()=>{
      if(staffSelected.value){
        $bvToast.toast('複製成功', {
          title: '剪貼簿複製',
          variant: 'success'
        })

        let UrlData = {
          StaffNo: staffSelected.value.value,
          Date: '2022-11-11',
        }
        tools.clipboardCopy(tools.web.url('single/APS/APSKANUI01/' + tools.base64.encode(UrlData)))
      }
      else{
        $bvToast.toast('複製失敗，尚未選擇人員', {
          title: '剪貼簿複製',
          variant: 'danger'
        })
      }
    }

    // 產線選擇
    const ProdLine_Selected = (val)=>{
      let prodLine = departmentOptions.value.find(e => e.value === val.value)

      if(prodLine){
        
        departmentSelected.value = prodLine

        const data = {
          dictKey: prodLine.value,
          EffectiveDate: new Date().toDateString().substring(0, 10)
        }

        staffSelected.value = null
        return pageJs.api.apiGetProdLineEmployee(data)
          .then((res) => {
            tools.arrEx.clear(staffOptions.value)
            tools.arrEx.fill(staffOptions.value, res)
          })
          .catch((err) => { alert(err) })
      }
      
    }

    // 取得所有產線資訊
    const GetProdLine = ()=>{
      return pageJs.api.apiGetAllDepartment()
        .then((res) => {
          tools.arrEx.clear(departmentOptions.value)
          res.forEach((item) => {
            departmentOptions.value.push({
              label: (item?.DictValue ?? 'null') + ' ' + (item?.Remark ?? 'null'),
              value: item?.DictKey ?? 'null',
            })
          })
        })
        .catch((err) => {
          alert(err)
        })
    }

    // 人員選擇
    const Set_Query_StaffNo = (val)=>{
      staffSelected.value = staffOptions.value.find(e=>e.value === val.value)
      store.commit(`${pageJs.page.pageInfo.serviceName}/SET_DATAINTERVAL_WORKOBJNO`, val);
      emit('refCalendar');
    }

		onMounted(()=>{
      GetProdLine().then(()=>{
        // 傳入參數
        const singleProps = reactive({
            staffNo: '',
            date: '',
            lineCode: '',
        })

        if(pageJs.page?.route?.params?.data ?? null != null){
            let obj = tools.base64.decode(pageJs.page.route.params.data)
            singleProps.staffNo = obj?.StaffNo ?? singleProps.staffNo
            singleProps.date = obj?.Date ?? singleProps.date

            pageJs.api.apiGetEmplyeeInfo({
                staffNo: singleProps.staffNo,
                date: singleProps.date
            }).then((data)=>{
                singleProps.lineCode = data?.lineCode ?? singleProps.lineCode
                departmentSelected.value = departmentOptions.value.find(e=>e.label.split(' ')[0] === singleProps.lineCode)
                if(departmentSelected.value){
                  ProdLine_Selected(departmentSelected.value).then(()=>{
                    Set_Query_StaffNo({
                      label: '',
                      value: singleProps.staffNo
                    })
                  })
                }
            })
        }
        
        tools.debug.log({tag: 'DEBUG', title: '人員行事曆', content: 'url傳get參數'}, singleProps)
      })
    })
    
    return {
      departmentOptions,
      staffOptions,
      departmentSelected,
      Set_Query_StaffNo,
      isReadonly,
      ProdLine_Selected,
      staffSelected,
      CopyButtonClick,
    }
  }
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.card-header {
  align-items: end;
}
.button-copy-url {
  text-align: right;
}
</style>
